import { BrowserRouter as Router } from 'react-router-dom';

import AppRouter from './routes/AppRouter';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div>
          <AppRouter />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
